module.exports = __webpack_public_path__ + "static/img/header.2b90ef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zhetian/header.png
// module id = 1UBo
// module chunks = 5